import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {

  }

  open(event) {
   let ActiveMegaMenuSelector = document.querySelector(`.mega-active`)
   let megaMenuSelector = document.querySelector(`#${event.params.key}`)

    if ( ActiveMegaMenuSelector ) {
      ActiveMegaMenuSelector.classList.remove('mega-active')
    }

   if ( megaMenuSelector ) {
      megaMenuSelector.classList.add('mega-active')
   }
  }

  close(event) {
    let ActiveMegaMenuSelector = document.querySelector(`.mega-active`)
    if ( ActiveMegaMenuSelector ) {
      ActiveMegaMenuSelector.classList.remove('mega-active')
    }
  }
}
